import {
  Button,
  ButtonProps,
  Divider,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { MdPerson } from '@react-icons/all-files/md/MdPerson';
import { FaChevronDown } from 'react-icons/fa';

import ProfileModal from '../../../components/ProfileModal';
import { useAccountMenu } from '../../../hooks';
import { titleCase } from '../../../utils/helpers';

const AuthMenu = ({ ...props }: Omit<ButtonProps, 'aria-label'>) => {
  const {
    customer,
    hasAccount,
    isOnDashboard,
    goToDashboard,
    handleLogout,
    profileModalOpen,
    setProfileModalOpen,
  } = useAccountMenu();

  return (
    <>
      <Menu>
        <MenuButton
          aria-label="Profile"
          as={Button}
          p={0}
          variant="ghost"
          _active={{ outline: 'none', bg: 'transparent' }}
          _focus={{ outline: 'none', bg: 'transparent' }}
          _hover={{ bg: 'transparent' }}
          leftIcon={<Icon as={MdPerson} boxSize="26px" />}
          rightIcon={<Icon as={FaChevronDown} boxSize="12px" />}
          pos="relative"
          {...props}
        >
          {customer && (
            <Text textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap" maxW="120px">
              {titleCase(`${customer?.first_name} ${customer?.last_name?.charAt(0)}`)}
            </Text>
          )}
        </MenuButton>
        <MenuList zIndex="99">
          <>
            {hasAccount && (
              <MenuItem onClick={() => setProfileModalOpen(true)} gap={1}>
                Profile
              </MenuItem>
            )}
            {!isOnDashboard && <MenuItem onClick={goToDashboard}>My Dashboard</MenuItem>}
            <Divider mx={4} w="auto" />
          </>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </MenuList>
      </Menu>
      <ProfileModal open={profileModalOpen} setOpen={setProfileModalOpen} customer={customer} />
    </>
  );
};

export default AuthMenu;
